/**
 * @flow
 * @relayHash 93e6996287288a112393c6f8b240e77e
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type CreateTutoringCompanyMutationVariables = {|
  input: {
    name: string;
    description: string;
    referralCode: string;
    internalMargin: number;
    externalMargin: number;
    clientMutationId?: ?string;
  };
|};
export type CreateTutoringCompanyMutationResponse = {|
  +createTutoringCompany: ?{|
    +clientMutationId: ?string;
    +tutoringCompany: ?{|
      +id: string;
    |};
  |};
|};
*/


/*
mutation CreateTutoringCompanyMutation(
  $input: CreateTutoringCompanyMutationInput!
) {
  createTutoringCompany(input: $input) {
    clientMutationId
    tutoringCompany {
      id
      ...EditTutoringCompany_company
    }
  }
}

fragment EditTutoringCompany_company on TutoringCompany {
  id
  name
  description
  referralCode
  internalMargin
  externalMargin
  studentCount
  students {
    edges {
      node {
        id
        fullname
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "CreateTutoringCompanyMutationInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateTutoringCompanyMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CreateTutoringCompanyMutationInput!"
          }
        ],
        "concreteType": "CreateTutoringCompanyMutationPayload",
        "name": "createTutoringCompany",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TutoringCompany",
            "name": "tutoringCompany",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "FragmentSpread",
                "name": "EditTutoringCompany_company",
                "args": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "CreateTutoringCompanyMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "CreateTutoringCompanyMutationInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "CreateTutoringCompanyMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CreateTutoringCompanyMutationInput!"
          }
        ],
        "concreteType": "CreateTutoringCompanyMutationPayload",
        "name": "createTutoringCompany",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TutoringCompany",
            "name": "tutoringCompany",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "description",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "referralCode",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "internalMargin",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "externalMargin",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "studentCount",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "StudentConnection",
                "name": "students",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "StudentEdge",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Student",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "fullname",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation CreateTutoringCompanyMutation(\n  $input: CreateTutoringCompanyMutationInput!\n) {\n  createTutoringCompany(input: $input) {\n    clientMutationId\n    tutoringCompany {\n      id\n      ...EditTutoringCompany_company\n    }\n  }\n}\n\nfragment EditTutoringCompany_company on TutoringCompany {\n  id\n  name\n  description\n  referralCode\n  internalMargin\n  externalMargin\n  studentCount\n  students {\n    edges {\n      node {\n        id\n        fullname\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/modules/admin/company/mutations/__generated__/CreateTutoringCompanyMutation.graphql.js